<template>
	<div>
		<section class="add-note-container">
			<textarea
				v-model="noteText"
				@keyup="adjustCharacterCount()"
				placeholder="Type your note here..."
				maxlength="500"
			></textarea>
			<div class="note-character-counter">
				<span :class="{ 'counter-end-warning': charCount >= 490 }">{{
					charCount
				}}</span
				>/500
			</div>
		</section>
		<footer class="footer-buttons">
			<button
				class="b360-btn b360-modal-action-btn"
				:class="{ success: success }"
				@click="handleNoteSave"
			>
				<span v-if="!waiting && !success">Save</span>
				<font-awesome-icon
					class="waiting-animation"
					:icon="['far', 'circle-notch']"
					v-if="waiting"
				/>
				<font-awesome-icon
					class="success-animation"
					:icon="['far', 'check']"
					v-if="success"
				/>
			</button>
			<button class="b360-btn b360-modal-cancel-btn" @click="$emit('close')">
				Cancel
			</button>
		</footer>
	</div>
</template>

<script>
import leadsService from '@/services/contacts/leads-service.js';
import alertsService from '@/services/contacts/alerts-service.js';

export default {
	name: 'AddNoteModal',
	props: {
		leadId: Number,
		alertId: Number,
		type: String,
	},
	data() {
		return {
			charCount: 0,
			noteText: '',
			waiting: false,
			success: false,
		};
	},
	methods: {
		adjustCharacterCount() {
			this.charCount = this.noteText.length;
		},
		async handleNoteSave() {
			let payload = {};

			if (this.type === 'alert') {
				payload = {
					alertId: this.alertId,
					saveNoteRequest: {
						content: this.noteText,
					},
				};
			} else if (this.type === 'lead') {
				payload = {
					leadId: this.leadId,
					saveNoteRequest: {
						content: this.noteText,
					},
				};
			}

			this.waiting = true;
			try {
				if (this.type === 'alert') {
					await alertsService.saveAlertNote(payload);
					this.waiting = false;
					this.success = true;
					// This is here so that the user can see the success state before the view switches
					setTimeout(() => {
						this.$emit('alertNoteSaved');
						this.success = false;
					}, 1500);
				} else if (this.type === 'lead') {
					await leadsService.saveLeadNote(payload);
					this.waiting = false;
					this.success = true;
					// This is here so that the user can see the success state before the view switches
					setTimeout(() => {
						this.$emit('leadNoteSaved');
						this.success = false;
					}, 1500);
				}
			} catch (error) {
				this.waiting = false;
				this.error = error;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.add-note-container {
	@include rem('padding', 20px);

	textarea {
		box-sizing: border-box;
		width: 100%;
		@include rem('height', 130px);
		border-radius: 6px;
		border: 1px solid $border-color-light;
		resize: none;
		@include rem('padding', 15px);
		@include typo--roboto__regular;
		@include rem('font-size', 16px);

		&::placeholder {
			@include typo--roboto__regular;
			@include rem('font-size', 16px);
		}
	}
}

.note-character-counter {
	display: flex;
	justify-content: flex-end;
	@include rem('margin-top', 5px);
}

.counter-end-warning {
	color: $error;
}

.footer-buttons {
	border-top: 1px solid $border-color-light;
	@include rem('padding', 15px 20px);
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 20px;

	.b360-modal-action-btn {
		margin-left: 0;

		&.success {
			background: $success;
		}
	}
}
</style>
